<template>
  <v-select
    :items="items"
    item-text="name"
    item-value="dir"
    label="Theme"
    v-model="theme"
    @change="onChange"
    :outlined="$store.getters.localSettings('outlinedInputs')"
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
const ALL_DOC_THEMES = gql`
  query allDocThemes {
    documentThemes {
      edges {
        node {
          dir
          description
          name
        }
      }
    }
  }
`;
export default {
  name: "document-theme-list-select",

  props: {
    value: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      theme: this.value,
    };
  },
  computed: {
    items() {
      return this.documentThemes
        ? this.documentThemes.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.theme = newVal;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.theme);
    },
  },

  apollo: {
    documentThemes: {
      query: ALL_DOC_THEMES,
    },
  },
};
</script>
 
<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/documents/DocumentThemeListSelect.vue